const actions = {
  SET_STATE: 'orders/SET_STATE',
  RESET_STATE: 'orders/RESET_STATE',
  GET_ORDERS: 'orders/GET_ORDERS',
  UPDATE_ORDER: 'orders/UPDATE_ORDER',
}

export default actions
